<template>
  <v-dialog v-model="dialog_cupomform" lazy persistent max-width="600px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">Cupom</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="coupon"
                  :rules="[
                    (v) => !!v || 'Por favor, preencher o nome do cupom.',
                    (v) =>
                      (v.length >= 5 && v.length <= 25) ||
                      'Por favor, o nome do cupom deve ter entre 5 e 15 caracteres.',
                    (v) =>
                      !!this.duplicateCoupon(v) ||
                      'Esse cupom já existe cadastrado',
                  ]"
                  label="Cupom*"
                  prepend-icon="sell"
                  class="purple-input"
                  @keyup="uppercaseCoupon"
                  required
                />
              </v-flex>
              <v-flex xs6 sm3 md3>
                <v-text-field
                  v-model.number="discount"
                  :rules="discountRules"
                  label="Valor de Desconto*"
                  prepend-icon="paid"
                  class="purple-input"
                  required
                  type="number"
                />
              </v-flex>
              <v-flex xs6 sm3 md3>
                <v-text-field
                  v-model.number="limit"
                  label="Limite de Uso*"
                  prepend-icon="paid"
                  class="purple-input"
                  required
                  hint="Se 0 (Zero) é ilimitado"
                  type="number"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  v-model="description"
                  :rules="descriptionRules"
                  required
                  label="Objetivo do Cupom"
                  hint="Descreva o objetivo da promoção"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="start_at"
                  label="Data de Inicio*"
                  persistent-hint
                  prepend-icon="event"
                  :rules="[
                    (v) => !!v || 'Por favor, preencher o nome do cupom.',
                    (v) =>
                      !!startDate(v) ||
                      'Data inválida ou maior que a Data de Validade!',
                  ]"
                  mask="####-##-##"
                  return-masked-value
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="expire_at"
                  label="Data de Validade*"
                  persistent-hint
                  prepend-icon="event"
                  :rules="[
                    (v) => !!v || 'Por favor, preencher o nome do cupom.',
                    (v) => !!validDateExpire(v) || 'Data inválida!',
                  ]"
                  mask="####-##-##"
                  return-masked-value
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  :items="power_plants"
                  item-text="name"
                  item-value="power_plant_id"
                  label="Planta*"
                  v-model="power_plant_id"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model.number="percentage_discount"
                  label="Percentual de Desconto Personalizado"
                  :rules="[
                    (v) =>
                      !v ||
                      (v >= 5 && v < 100) ||
                      'Se deseja informar desconto personalizado, esse deve ser entre 5 e 99.',
                  ]"
                  mask="##"
                  return-masked-value
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            flat
            @click="dialog_cupomform = false"
            :disabled="loading_coupon"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            :dark="valid || !loading_coupon"
            @click="submit"
            :loading="loading_coupon"
            :disabled="!valid || loading_coupon"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="6000"
      :top="true"
    >
      {{ snackbar_message }}
      <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";
import moment from "moment";
import { getPowerPlants } from "../../services/power_plant_fb.js";
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    valid: false,
    coupon: "",
    couponRules: [
      (v) => !!v || "Por favor, preencher o nome do cupom.",
      (v) =>
        (v.length >= 5 && v.length <= 25) ||
        "Por favor, o nome do cupom deve ter entre 5 e 15 caracteres.",
      (v) => !!this.duplicateCoupon(v) || "Esse cupom já existe cadastrado",
    ],
    description: "",
    descriptionRules: [
      (v) => !!v || "Por favor, preencher o objetivo desse cupom.",
    ],
    discount: 50,
    discountRules: [
      (v) => !!v || "Por favor, preencher o valor de desconto do cupom.",
      (v) => v > 0 || "Por favor, o cupom precisa gerar desconto.",
    ],
    status: "",
    menuStart_at: false,
    start_at: moment().format("YYYY-MM-DD"),
    // startDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    startDateFormatted: moment().subtract(7, "days").format("DD/MM/YYYY"),
    start_atRules: [
      (v) => !!v || "Por favor, preencher o nome do cupom.",
      (v) =>
        (v.length >= 5 && v.length <= 15) ||
        "Por favor, o nome do cupom deve ter entre 5 e 15 caracteres.",
    ],
    limit: 0,
    power_plant_id: null,
    power_plants: [],
    percentage_discount: null,
    menuExpire_at: false,
    expire_at: moment().add(30, "days").format("YYYY-MM-DD"),
    // expire_atFormatted: moment().add(1, 'days').format('DD/MM/YYYY'),
    dialog_cupomform: false,
    loading_coupon: false,
    snackbar: false,
    snackbar_message: null,
  }),
  mounted() {
    eventBus.$on("dialog_cupomform", (dialog_cupomform) => {
      this.dialog_cupomform = dialog_cupomform;
      // console.log('user', user)
    });
    getPowerPlants()
      .then((pps) => {
        this.power_plants = pps.docs.map((pp) => {
          return { id: pp.id, ...pp.data() };
        });
      })
      .catch((err) => console.error(err));
  },
  computed: {
    ...mapState("marketing", ["coupons"]),
  },
  methods: {
    ...mapActions("marketing", ["createCoupon"]),
    validDateExpire(val) {
      if (!val) return;
      if (!moment(val).isValid()) return false;
      return moment(val) > moment();
    },
    startDate(val) {
      if (!val) return;
      if (!moment(val).isValid()) return false;
      return moment(val) < moment(this.expire_at);
    },
    duplicateCoupon(val) {
      if (!val) return;
      else if (!this.coupons) return;
      let has = this.coupons.filter((el) => el.coupon === val);
      return has.length <= 0;
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.loading_coupon = true;
      const coupon_data = {
        created_at: new Date(),
        updated_at: new Date(),
        coupon: this.coupon,
        description: this.description,
        discount: this.discount,
        activated: true,
        start_at: this.start_at,
        expire_at: this.expire_at,
        limit: this.limit,
        used: 0,
      };
      if (this.power_plant_id) coupon_data.power_plant_id = this.power_plant_id;
      if (this.percentage_discount)
        coupon_data.percentage_discount = this.percentage_discount;
      this.createCoupon(coupon_data)
        .then(() => {
          this.snackbar_message = "Cupom criado com sucesso!";
          this.snackbar = true;
          this.loading_coupon = false;
          this.dialog_cupomform = false;
        })
        .catch((err) => {
          this.snackbar_message = "Erro ao criar Cupom! " + err;
          this.snackbar = true;
          this.loading_coupon = false;
        });
    },
    uppercaseCoupon() {
      this.coupon = this.coupon ? this.coupon.toUpperCase() : "";
    },
  },
};
</script>
